export default "__VITE_ASSET__5747d536__"